<template>
  <div class="ocr-context-bar" :class="{ 'ocr-context-bar--sidebar': sidebar }">
    <div class="ocr-context-fields">
      <div class="ocr-context-item ocr-context-item--folder">
        <label class="profile-menu-label">{{ sidebar ? "Folder" : "Tenant folder" }}</label>
        <v-select
          :model-value="selected"
          :items="folderOptions"
          class="profile-menu-tenant ocr-folder-select"
          placeholder="Select folder"
          hide-details
          variant="outlined"
          density="comfortable"
          menu-icon="mdi-chevron-down"
          :loading="loading"
          @update:model-value="$emit('select', $event)"
        />
      </div>
    </div>
    <div class="ocr-context-actions" :class="{ 'ocr-context-actions--stacked': sidebar }">
      <v-btn size="small" color="primary" variant="flat" class="ocr-toolbar-btn" @click="showCreate = true">
        New
      </v-btn>
      <v-btn
        size="small"
        variant="outlined"
        color="error"
        class="ocr-toolbar-btn"
        :disabled="selected === baseName"
        @click="confirmDelete"
      >
        Delete
      </v-btn>
    </div>

    <v-dialog v-model="showCreate" max-width="440">
      <v-card class="ocr-dialog-card">
        <v-card-title class="ocr-dialog-title">New folder</v-card-title>
        <v-card-text>
          <div class="ocr-field">
            <label class="profile-menu-label">Folder name</label>
            <v-text-field
              v-model="newName"
              variant="outlined"
              density="comfortable"
              hide-details
            />
          </div>
        </v-card-text>
        <v-card-actions class="ocr-dialog-actions">
          <v-spacer />
          <v-btn variant="text" @click="showCreate = false">Cancel</v-btn>
          <v-btn color="primary" variant="flat" @click="createFolder">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "OcrFolderPanel",
  props: {
    loading: { type: Boolean, default: false },
    folders: { type: Array, default: () => [] },
    baseName: { type: String, default: "base" },
    selected: { type: String, default: "base" },
    sidebar: { type: Boolean, default: false },
  },
  emits: ["select", "create", "delete"],
  data() {
    return { showCreate: false, newName: "" };
  },
  computed: {
    folderOptions() {
      return [this.baseName, ...this.folders.filter((f) => f !== this.baseName)];
    },
  },
  methods: {
    createFolder() {
      const name = this.newName.trim();
      if (!name) return;
      this.$emit("create", name);
      this.newName = "";
      this.showCreate = false;
    },
    confirmDelete() {
      if (this.selected === this.baseName) return;
      if (window.confirm(`Delete folder "${this.selected}" and all contents?`)) {
        this.$emit("delete", this.selected);
      }
    },
  },
};
</script>
